/* eslint-disable no-console */
import * as React from "react";

import { graphql } from "gatsby";

export interface OptimizedVideoProps {
  video: Queries.SanityFile;
  alt?: string | null;
  style?: React.CSSProperties;
}

const OptimizedVideo: React.FC<OptimizedVideoProps> = ({
  video,
  style,
  alt,
}) => {
  const videoData = video?.asset?.localFile;

  if (!videoData) {
    if (process.env.NODE_ENV === "development") {
      console.warn("Missing video data", video);
    }

    return null;
  }

  const poster = videoData.videoScreenshots?.[0]?.localURL;
  const h265 = videoData.videoH265?.path;
  const vp9 = videoData.videoVP9?.path;
  const h264 = videoData.videoH264?.path;

  if (!poster) console.warn("Missing video screenshot");
  if (!h265) console.warn("Missing video h265");
  if (!vp9) console.warn("Missing video vp9");
  if (!h264) console.warn("Missing video h264");

  return (
    <video
      poster={poster ?? undefined}
      style={style}
      autoPlay
      muted
      loop
      playsInline
    >
      {h265 && <source src={h265} type="video/mp4; codecs=hevc" />}
      {vp9 && <source src={vp9} type="video/webm; codecs=vp9,opus" />}
      {h264 && <source src={h264} type="video/mp4; codecs=avc1" />}
      {poster && <img src={poster} alt={alt ?? ""} />}
    </video>
  );
};

export const query = graphql`
  fragment OptimizedVideo on SanityFile {
    asset {
      url

      localFile {
        videoH264 {
          path
        }
        videoH265 {
          path
        }
        videoVP9 {
          path
        }
        videoScreenshots(timestamps: ["0"]) {
          localURL
        }
      }
    }
  }
`;

export default OptimizedVideo;
